module.exports = __webpack_public_path__ + "static/media/3.fb716f41.mp3";